/**
 * Pillars Block.
 * 
 */

/**
 * Desktop: Expand-collapse functionality of Pillars capsules and content.
 * Mobile: 
 */

let 
	$window = $(window),
	$pillarsContainer = $('.pillars-block__pillars'),
	$pillars,			// Mobile or desktop pillars. Each has different click functionality.
	$pillarsContent = $pillarsContainer.find('.pipeline-block__pillar-content'),
	$myPillar,			// Clicked pillar.
	myId,				// Clicked pillar data-id.
	$myPillars,			// Mobile and desktop clicked pillars and content.
	$myContent,			// Content of clicked pillar.
	$currPillar,		// Currently active pillar.
	$currPillars,		// Mobile and desktop currently active pillars and content.
	$currContent;		// Content of currently active pillar.

function preserveMobileState() {
	// When crossing breakpoint from mobile to desktop, preserve current itneractive state.
	// console.log("PILLARS: preserveMobileState");
	$pillarsContent.css('display','block');
}

function preserveDesktopState() {
	// When crossing breakpoint from desktop to mobile, preserve current itneractive state.
	// console.log("PILLARS: preserveDesktopState");
	$pillarsContent.css('display','none');
	$pillarsContent.filter('.active').slideDown(300);
}

function initPillarsMobile() {
	// console.log('PILLARS: initPillarsMobile()');

	$pillars = $pillarsContainer.find('.mobile'),
	$pillars.on('click', function() {
		// console.log('CLICK PILLAR');

		$myPillar = $(this);
		myId = $myPillar.data('id');
		$myPillars = $pillarsContainer.find('.'+myId);
		$myContent = $pillarsContainer.find('#'+myId);
		$currPillar = $pillars.filter('.active');
		$currPillars = $pillarsContainer.find('.active');
		$currContent = $pillarsContent.filter('.active');

		if (!$myPillar.hasClass('active')) {
			// console.log('CLICK: '+$(this).data('id'));
			// Collapse currently active pillar.
			// $currPillar.removeClass('active');
			// $currPillar.find('.button-excol').removeClass('expanded');
			$currPillars.removeClass('active');
			$currPillars.find('.button-excol').removeClass('expanded');
			$currContent.slideUp(300);
			// Expand clicked pillar.
			// $myContent.addClass('active');
			// $myPillar.addClass('active');
			// $myPillar.find('.button-excol').addClass('expanded');
			$myPillars.addClass('active');
			$myPillars.find('.button-excol').addClass('expanded');
			$myContent.slideDown(300);
			window.setTimeout(function() {
				$pillarsContainer.find('.desktop').addClass('hide');
				$myPillars.removeClass('hide');
			}, 400);

		} else {
			// Collapse clicked pillar. Return to default states.
			$myPillars.removeClass('active');
			$myPillars.find('.button-excol').removeClass('expanded');
			$myContent.slideUp(300);
			window.setTimeout(function() {
				$pillarsContainer.find('.desktop').removeClass('hide');
			}, 400);
		}
	});
}

function initPillarsDesktop() {
	// console.log('PILLARS: initPillars()');
	
	$pillars = $pillarsContainer.find('.desktop'),
	$pillars.on('click', function() {

		$myPillar = $(this);
		myId = $myPillar.data('id');
		$myPillars = $pillarsContainer.find('.'+myId);
		$myContent = $pillarsContainer.find('#'+myId);
		$currPillar = $pillars.filter('.active');
		$currPillars = $pillarsContainer.find('.active');
		$currContent = $pillarsContent.filter('.active');

		if (!$myPillar.hasClass('active')) {
			// console.log('CLICK: '+$(this).data('id'));
			// Collapse currently active pillar.
			$currPillars.removeClass('active');
			$currPillars.find('.button-excol').removeClass('expanded');
			// Expand clicked pillar.
			$myPillars.addClass('active');
			$myPillars.find('.button-excol').addClass('expanded');
			$pillarsContainer.find('.desktop').addClass('hide');
			$myPillars.removeClass('hide');
		} else {
			// Collapse clicked pillar. Return to default states.
			$myPillars.removeClass('active');
			$myPillars.find('.button-excol').removeClass('expanded');
			$pillarsContainer.find('.desktop').removeClass('hide');
			if (myId != 'pillar-2') {
				$pillarsContainer.find('.pillar-2').css('transition', 'all 0.5s cubic-bezier(0.455, 0.03, 0.515, 0.955)');
				window.setTimeout(function() {
					$pillarsContainer.find('.pillar-2').css('transition','');
				}, 500);
			}
		}
	});
}

let 
	prevWidth;

function initResizeWatcher() {
	// console.log('PILLARS: initResizeWatcher()');

    $window.on('resize', function() {
        if ($window.width() >= 1024) {
			if (prevWidth < 1024) {
				// console.log('PILLARS: mobile to desktop');
				preserveMobileState();
			}
		} else {
			if (prevWidth >= 1024) {
				// console.log('PILLARS: desktop to mobile');
				preserveDesktopState();
			}
		}
		prevWidth = $window.width();
    });
}

exports.init = function () {
	// console.log('PILLARS: exports.init');
	// Run init methods...

	initPillarsMobile();
	initPillarsDesktop();
	initResizeWatcher();
};